import { useState } from 'react';
import queryString from 'query-string';
import LocationListingContext, {
    type LocationListingContextProps,
    type LocationListingProps,
    type LocationListingView,
    VIEW_LISTING,
    VIEW_MAP
} from './LocationListingContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';


interface LocationListingProviderProps extends LocationListingProps {
    children: React.ReactNode;
}

const LocationListingProvider = (props: LocationListingProviderProps): JSX.Element => {
    const { children, map, listing, serverPageUrl, defaultView: defaultViewProp, ...assetsListingProps } = props;

    const resolvedDefaultView = (defaultViewProp === VIEW_MAP && !!map.apiKey) ? VIEW_MAP : VIEW_LISTING;

    const isBrowser = typeof window !== 'undefined';
    const fallbackSearchQuery = isBrowser
        ? (window?.location?.search ?? '')
        : '';

    const initialView = queryString.parse(fallbackSearchQuery).view as LocationListingView || resolvedDefaultView;

    const [activeItemId, setActiveItemId] = useState<string>('');
    const [view, setView] = useState<LocationListingView>(initialView);
    const [page, setPage] = useState(getPageFromURL(new URL(serverPageUrl).search));

    const activeFiltersInitialValue = view === VIEW_MAP && map ?
        getActiveFiltersFromURL(map.filters, new URL(serverPageUrl).search) :
        getActiveFiltersFromURL(listing.filters, new URL(serverPageUrl).search);

    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const providerValue: LocationListingContextProps = {
        view,
        setView,
        defaultView: resolvedDefaultView,
        activeItemId,
        setActiveItemId,
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        map,
        listing,
        serverPageUrl,
        ...assetsListingProps,
    };

    return (
        <LocationListingContext.Provider value={providerValue}>
            {children}
        </LocationListingContext.Provider>
    );
};

export default LocationListingProvider;
